import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { clearAuth, setAuthenticated } from '../../../store/slices/authSlice'
import { DEV_BYPASS_USER, isDevAuthBypassActive } from '../devBypass'
import { useAuth } from '../hooks/useAuth'

export type AuthGuardProps = {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const bypass = isDevAuthBypassActive()
  const { isAuthenticated, isLoading, user } = useAuth()
  const dispatch = useDispatch()

  useEffect(() => {
    if (bypass) {
      dispatch(setAuthenticated({ isAuthenticated: true, userEmail: DEV_BYPASS_USER.email }))
      return
    }
    if (isAuthenticated) {
      dispatch(setAuthenticated({ isAuthenticated: true, userEmail: user?.email }))
    } else if (!isLoading) {
      dispatch(clearAuth())
    }
  }, [bypass, isAuthenticated, isLoading, user?.email, dispatch])

  if (bypass) {
    return <>{children}</>
  }

  if (isLoading) {
    return <LoadingSpinner label="Loading..." />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default AuthGuard
